module.exports = require("@magento/peregrine/lib/util/simplePersistence");